import React from "react";
import { useRecoilState } from "recoil";
import { policyHolderState } from "../../state/QuoteState";
import CustomDivider from "../../components/CustomDivider";
import SummaryItem from "../../components/SummaryItem";

const PolicyHolderSummary = ({ onEdit }: { onEdit: () => void }) => {
  const [
    {
      day,
      email,
      employmentStatus,
      gender,
      idNumber,
      idType,
      maritalStatus,
      mobilePhoneNumber,
      month,
      name,
      surname,
      title,
      year,
    },
  ] = useRecoilState(policyHolderState);
  return (
    <>
      <SummaryItem items={[idNumber, idType]} onEdit={onEdit}>
        Policy holder ID
      </SummaryItem>
      <CustomDivider />
      <SummaryItem items={[title, name, surname]} onEdit={onEdit}>
        Policy holder name
      </SummaryItem>
      <CustomDivider />
      <SummaryItem items={[`${day}-${month}-${year}`]} onEdit={onEdit}>
        Date of birth
      </SummaryItem>
      <CustomDivider />
      <SummaryItem
        items={[gender, maritalStatus, employmentStatus]}
        onEdit={onEdit}
      >
        Further information
      </SummaryItem>
      <CustomDivider />
      <SummaryItem items={[mobilePhoneNumber, email]} onEdit={onEdit}>
        Contact data
      </SummaryItem>
    </>
  );
};

export default PolicyHolderSummary;
